<script setup lang="ts">
export interface LiveMarketItemProps {
  title: string;
  subTitle?: string;
  image?: string;
}

defineProps<LiveMarketItemProps>();
</script>

<template>
  <div class="live-market-item d-flex gap-2 align-items-center">
    <img class="img-fluid" style="max-width: 34px" :alt="title" :src="image" />
    <div>
      <h5 class="m-0">{{ title }}</h5>
      <p class="m-0">{{ subTitle }}</p>
    </div>
  </div>
</template>
